export const mbSearch = {
  mainSearchBox: {
    searchOrderNo: 'Search / catalog no.',
    searchForArticle: 'Search for catalog no., product, topics and more...',
    clear: 'Clear',
    reset: 'Reset'
  },

  searchResultItem: {
    price: 'Price',
    priceFrom: 'Price from',
    products: 'Products',
    emptyResultTitle: 'Sorry, we couldn’t find a match for your search term.',
    emptyResultLine1: 'Please check your spelling and try again.',
    emptyResultLine2: 'If you know the catalog number of the item you are looking for, you can type it in directly in order to get to your product of interest.',
    regulatoryStatus: 'Different regulatory classifications apply for individual products',
    content: 'Content '
  },

  searchResultItemCms: {
    emptyResultTitle: 'Sorry, we couldn’t find a match for your search term.',
    emptyResultLineOne: 'Please check your spelling and try again.',
  },

  searchFilterPane: {
    filter: 'Filter',
    showMore: 'Show more filters',
    showLess: 'Show less filters',
    expandAll: 'expand all',
    collapseAll: 'collapse all',
    mobileHeaderTitle: 'Filter your results:',
    filteredBy: 'Filtered by:',
    and: 'AND',
    or: 'OR'
  },

  searchHeading: {
    title: '<strong>{{count}}</strong> result',
    title_other: '<strong>{{count}}</strong> results',
    titleLong: '<strong>{{count}}</strong> result for "{{query}}"',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    titleLong_other: '<strong>{{count}}</strong> results for "{{query}}"',
  },

  homepageSearch: {
    goToSearchResults: 'Go to search results',
    showMoreFacetFilters: 'Show more facet filters',
    showLessFacetFilters: 'Show less facet filters'
  }
}
